export default __webpack_public_path__ + "pin-green.81ae77c8.svg";